import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { useCheckout } from 'lib/modules/checkout'
import { MetaData } from 'components/MetaData'
import { CheckoutAside } from '../../components/CheckoutAside'
import { ShippingGuestMain } from './components/ShippingGuestMain'
import {
  Container,
  CheckoutLayout,
  CheckoutMain,
  ContentHeader,
  ShippingFormContainer,
  ShippingFirstContent
} from '../styled'

import { ShippingForm } from './components/Form'

export const Shipping = () => {
  const intl = useIntl()
  const { requiresShipping } = useCheckout()
  const { isLoggedIn } = useCustomer()
  const title = intl.formatMessage({ id: 'checkout.title' })
  const [firstContentClass, setFirstContentClass] = useState('')
  const [headerTitle, setHeaderTitle] = useState(isLoggedIn ? 'checkout.header.shipping' : 'checkout.account.login')

  const handleChangeContentClass = (classValue: string, headerValue: string) => {
    setFirstContentClass(classValue)
    setHeaderTitle(headerValue)
  }

  if (!requiresShipping()) {
    return (
      <Redirect to='/checkout/billing' />
    )
  }

  return (
    <>
      <MetaData
        title={title}
      />
      <Container>
        <h1>{title}</h1>
        <CheckoutLayout>
          <CheckoutMain>
            <ContentHeader>
              <span>{intl.formatMessage({ id: headerTitle })}</span>
            </ContentHeader>
            {!isLoggedIn
              ? (
                <ShippingFirstContent className={firstContentClass}>
                  <ShippingGuestMain setFirstContentClass={handleChangeContentClass} />
                </ShippingFirstContent>
              )
              : (
                <ShippingFormContainer>
                  <ShippingForm />
                </ShippingFormContainer>
              )}
          </CheckoutMain>
          <CheckoutAside />
        </CheckoutLayout>
      </Container>
    </>
  )
}
